export default "//static.tradera.net/touchweb/static/output/images/category-home-household.c0b69fbe.svg";